const TRACK_USAGE_EVENT_TYPE = '@@usageTracker/TRACK_USAGE';
const usageTrackerMiddleware = trackCallback => __store => next => action => {
  if (action && action.type && action.type === TRACK_USAGE_EVENT_TYPE) {
    const {
      eventName,
      options
    } = action.payload;
    trackCallback(eventName, options);
  }
  return next(action);
};
export default usageTrackerMiddleware;